
import React, { useEffect, useState } from "react";
import ActionButton from "../../components/ActionButton";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import DashboardLayout from "../../components/DashboardLayout";
import DashboardCard from "../../components/DashboardCard";
import { LIGHT_BLUE_COLOR } from "../../constants";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useForm } from "react-hook-form";
import ShowErrorAlert from "../../components/ErrorAlert";
import { extractErrorMessage } from "../../utils";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import DashboardHeading from "../../components/DashboardHeading";
import Label from "../../components/Label";
import CustomInput from "../../components/CustomInput";
import { DOCUMENT_TYPE_FIELDS, PRICE_MASTER_FIELDS } from "./Config.constant";
import ConfigurationsHeader from "./ConfigurationsHeader";
import CustomSelect from "../../components/CustomSelect";
import ShowSuccessAlert from "../../components/SuccessAlert";

const UpdateDocumentType = () => {
    const { documentTypeId: id } = useParams();
    const navigate = useNavigate();

    const {
        handleSubmit,
        formState: { errors },
        getValues,
        control,
        reset
    } = useForm({
        defaultValues: {
            type: "",
            updateType: id
        }
    });

    // Redux Store
    const {
        auth: {
            token,
            user: { _id: userId },
        },
    } = useSelector((state) => state);

    // State Variables
    const [loading, setLoading] = useState(false);
    const [documentTypeId, setDocumentTypeId] = useState(id);
    const [documentTypes, setDocumentTypes] = useState(null);

    async function updateServiceTypeReq(body) {
        setLoading(true);
        try {
            await axios.put(`${BASE_URL}/users/${userId}/documentTypes/${documentTypeId}`, body, {
                headers: {
                    Authorization: token,
                },
            });
            // setLoading(false);
            ShowSuccessAlert('Document type updated successfully');
            setTimeout(()=>{
                setLoading(false);
                navigate("/admins/configurations/documentTypes");
            }, 2000);
            // getDocumentTypes();
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    async function getDocumentTypes(body) {
        setLoading(true);
        try {
            const {
                data: { documentTypes },
            } = await axios.get(`${BASE_URL}/users/${userId}/documentTypes`, {
                headers: {
                    Authorization: token,
                },
            });

            const priceMasterObj = preparePriceMasterObj(documentTypes);
            setDocumentTypes(priceMasterObj);
            // if(documentTypes && documentTypes.length > 0){
            //     setDocumentTypeId(documentTypes[0]._id);
            // }
            // reset({type: documentTypes[0].type})
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    const preparePriceMasterObj = (service) => {
        for (let [key, value] of service.entries()) {
            let selected = false;
            if (!key) selected = true;
            service[key] = { _id: value._id, label: value.type, value: value._id, selected, unit: value.typr }
        }
        return service;
    }

    function onSubmit(data) {
        updateServiceTypeReq(data);
    }

    function onChangePriceMaster(e) {
        const selectedIndex = e.target.selectedIndex;
        setDocumentTypeId(documentTypes[selectedIndex]._id);
        let updatedServiceType = [...documentTypes];
        for (let [index, serviceType] of updatedServiceType.entries()) {
            if (index !== selectedIndex) {
                serviceType.selected = false;
            } else {
                serviceType.selected = true;
            }
        }
        setDocumentTypes(updatedServiceType);
        reset({unit: documentTypes[selectedIndex].type})
    }

    useEffect(() => {
        getDocumentTypes();
    }, []);

    return (
        <DashboardLayout >
            <ConfigurationsHeader />
            <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex justify-between align-center">
                        <div className="flex align-center">
                            <Link to="/admins/configurations/documentTypes">
                                <MdOutlineArrowBackIosNew size={20} />
                            </Link>
                            <DashboardHeading>Update</DashboardHeading>
                        </div>
                        <ActionButton type="submit" disabled={loading}>
                            {loading ? <ClipLoader color="black" size={20} /> : "Update"}
                        </ActionButton>
                    </div>
                    {/* form starts here */}
                    <DashboardCard>
                        <CustomSelect
                            name={"updateType"}
                            control={control}
                            errors={errors}
                            errorText={"Document Type is required"}
                            options={documentTypes ? documentTypes : []}
                            onHandleChange={onChangePriceMaster}
                            disabled={true}
                        />
                        {DOCUMENT_TYPE_FIELDS(getValues).map(
                            ({ name, required, label, type, rules, errorText }) => (
                                <div key={name} className="mt-3">
                                    <Label required={required}>{label}</Label>
                                    <CustomInput
                                        name={name}
                                        type={type}
                                        control={control}
                                        rules={rules}
                                        errors={errors}
                                        errorText={errorText}
                                    />
                                </div>
                            )
                        )}
                    </DashboardCard>
                </form>
            </DashboardCard>
            {/* <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <div style={{display: "flex", flexDirection: "row"}}>
                <span style={{fontSize: "32px"}}>OR</span>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/documentTypes"  >
                <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                    <FiEdit color="white" size={20} className="me-2" />
                    <small>All Document Types</small>
                </ActionButton></Link>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/addDocumentType"  >
                <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                    <FiEdit color="white" size={20} className="me-2" />
                    <small>Add Document Type</small>
                </ActionButton></Link>
                </div>
            </DashboardCard> */}
        </DashboardLayout>

    )
}

export default UpdateDocumentType;